var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.component,{tag:"component",attrs:{"data":_vm.data,"moduleId":_vm.moduleId}})
}
var staticRenderFns = []

export { render, staticRenderFns }